<script>
    import {getContext} from "svelte";
    import PlaceAutocomplete from "@components/PlaceAutocomplete.svelte";

    export let customerData = {}
    export let error;

    let {org, location} = getContext('APP');

    const defaultCountry = $location && $location.country || org.countrycode;
    let formErrors = [];

    function customerAddressSelected({detail}) {
        if(detail) {
            customerData.zip = detail.postal_code;
            customerData.state = detail.state;
            customerData.city = detail.city;
            customerData.street = detail.line1;
            customerData.country = detail.country;
        }else{
            customerData.zip = '';
            customerData.state = '';
            customerData.city = '';
            customerData.street = '';
            customerData.country = '';
        }
    }
</script>

<style lang="scss">
  input.error {
    animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }

    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
</style>

<div class="w-full">
    <div class="mt-1 text-black w-full">
      <PlaceAutocomplete
        worldwide
        on:select={customerAddressSelected}
        placeholder="Enter shipping address"
        country={defaultCountry}
        bind:error={error}
        backgroundColor="white"
        colorScheme="light"
      />
      <div class="mt-4 sm:w-1/2 sm:pr-2">
        <label for="phone" class="text-left block mb-1">Phone number</label>
        <input type="text" name="phone" id="phone" bind:value={customerData.phonenumber}
               class:error={formErrors['phonenumber']} autocomplete="phone"
               class="block w-full h-[42px] rounded-md {formErrors['phonenumber'] ? 'border-red-400' : 'border-gray-300' } sm:text-sm">
      </div>
    </div>
    {#if error?.length}
      <div class="error">
      </div>
    {/if}
</div>
